import React from "react";
import { FormattedMessage } from "react-intl";
import tripStatus from "../constants/tripStates";

export default [
    {
        label: <FormattedMessage id="trip.client" />,
        labelDescriptorId: "trip.client",
        id: "client",
        entityName: "organizations",
        name: "name",
    },
    {
        label: <FormattedMessage id="trip.branch" />,
        labelDescriptorId: "trip.branch",
        id: "branchId",
        entityName: "branches",
        name: "nameAr",
    },
    {
        label: <FormattedMessage id="trip.driver" />,
        labelDescriptorId: "trip.driver",
        id: "driverId",
        entityName: "drivers",
        name: "name",
        showUnassignedOption: true,
    },
    {
        label: <FormattedMessage id="trip.supplier" />,
        labelDescriptorId: "trip.supplier",
        id: "supplierId",
        entityName: "suppliers",
        name: "name",
        showUnassignedOption: true,
    },
    {
        label: <FormattedMessage id="trip.truck" />,
        labelDescriptorId: "trip.truck",
        id: "truckId",
        entityName: "trucks",
        name: "plateNumber",
        showUnassignedOption: true,
    },
    {
        label: <FormattedMessage id="trip.truck-type" />,
        labelDescriptorId: "trip.truck-type",
        id: "truckTypeId",
        entityName: "truck-types",
        name: "alias",
    },
    {
        label: <FormattedMessage id="trip.status" />,
        labelDescriptorId: "trip.status",
        id: "status",
        data: Object.values(tripStatus),
    },
    {
        label: <FormattedMessage id="trip.client-user" />,
        labelDescriptorId: "trip.client-user",
        id: "user",
        entityName: "users",
        name: "email",
    },
    {
        label: <FormattedMessage id="trip.assignee" />,
        labelDescriptorId: "trip.assignee",
        id: "admin",
        entityName: "adminUsers",
        name: "email",
    },
    {
        id: "createdAt",
        type: "dateRange",
    },
];
